<template>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Редактирование параметров платежных систем</h3>
        <button type="button" class="close" @click="hide()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Производитель монетоприемника</label>
          <server-select
            v-model="coinsMachine.creator"
            endpoint="money_machine_creators/options"
            label="name"
          />
        </div>
        <div class="mb-1">Вмсестимость туб монетоприемника</div>
        <div class="d-flex">
        <div class="form-group mr-1">
          <label>Монет 1 руб.</label>
          <input type="number" class="form-control" v-model="coinsMachine.full_count_coin1">
        </div>
        <div class="form-group mr-1">
          <label>Монет 2 руб.</label>
          <input type="number" class="form-control" v-model="coinsMachine.full_count_coin2">
        </div>
        <div class="form-group mr-1">
          <label>Монет 5 руб.</label>
          <input type="number" class="form-control" v-model="coinsMachine.full_count_coin5">
        </div>
        <div class="form-group">
          <label>Монет 10 руб.</label>
          <input type="number" class="form-control" v-model="coinsMachine.full_count_coin10">
        </div>
        </div>
        <div class="form-group">
          <label>Производитель купюроприемника</label>
          <server-select
            v-model="banknotesMachine.creator"
            endpoint="money_machine_creators/options"
            label="name"
          />
        </div>
        <div class="form-group">
          <label>Вместимость стэкера купюроприемника</label>
          <v-multiselect
            v-model="banknotesMachine.full_count_banknotes"
            :options="[200, 375, 500]"
          />
        </div>
        <div class="form-group">
          <label>Тип кассовой ленты</label>
          <server-select
            v-model="kkt"
            endpoint="kkt/options"
            label="name"
          />
        </div>
        <!--<div class="form-group">-->
          <!--<label>Длина кассовой ленты</label>-->
          <!--<v-multiselect-->
            <!--v-model="kkt.length"-->
            <!--:options="[100, 200, 300]"-->
          <!--/>-->
        <!--</div>-->
        <div class="form-group">
          <label>Длина чека</label>
          <div class="input-group">
            <input
              type="number"
              class="form-control"
              v-model="voucherLength"
              min="0"
            >
            <span class="input-group-append"><span class="input-group-text">см</span></span>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex">
        <btn-action
          class="btn btn-primary ml-auto"
          @click="save"
        >Сохранить</btn-action>
      </div>
    </div>
  </div>
</template>
<script>
  import api from '@/api'

  export default {
    props: ['machine'],
    data () {
      return {
        coinsMachine: this.machine.coins_machine || {},
        banknotesMachine: this.machine.banknotes_machine || {},
        kkt: this.machine.kkt_type || {},
        voucherLength: this.machine.cash_voucher_length * 100,
      }
    },
    methods: {
      save () {
        const data = {
          coins_machine: this.coinsMachine,
          banknotes_machine: this.banknotesMachine,
          kkt_type: this.kkt,
          cash_voucher_length: this.voucherLength / 100,
        }
        api.put(`machines/${this.machine.id}/money`, data).then(({data}) => this.hide(data))
      },
      hide (data = null) {
        this.$emit('hide', data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/machines/modals/money-modal.vue